export default function Marquee({ items, tone = "terracotta", slow = false, testid = "marquee" }) {
  const row = items.map((i) => `${i}  ★  `).join("");
  const tones = {
    terracotta: "bg-terracotta text-sand border-black/10",
    night: "bg-night text-gold border-white/10",
    teal: "bg-teal text-sand border-black/10",
  };
  return (
    <div
      data-testid={testid}
      className={`overflow-hidden border-y py-3.5 select-none ${tones[tone]}`}
      aria-hidden="true"
    >
      <div className={`flex whitespace-nowrap ${slow ? "animate-marquee-slow" : "animate-marquee"} font-serif italic text-lg tracking-wide`}>
        <span className="pr-4">{row}</span>
        <span className="pr-4">{row}</span>
      </div>
    </div>
  );
}
